import { ReactNode, createContext } from 'react';
import { API } from '@shared/types/api';

export const ViewTemplateContext = createContext<API.ViewTemplateFragment | null>(null);

interface Props {
  template: API.ViewTemplateFragment | null;
  children: ReactNode;
}

export function BlockViewTemplateProvider({ template, children }: Props) {
  return <ViewTemplateContext.Provider value={template}>{children}</ViewTemplateContext.Provider>;
}
